<template>
    <van-notice-bar wrapable :scrollable="false" color="#484848" background="#F1F1F1" left-icon="records">
        <p class="text3Indentation">本结果核心是基于北京友谊医院、安贞医院的顶级专家经验，充分依据《中国心血管病一级预防指南》和美国国家心肺和血液研究所的MESA指南！
            可以较为全面、科学、真实的反映个人心脏当前的风险状态。注：风险只是一种身体当前状态反映，科学的应对和良好的心态更为重要!</p>
    </van-notice-bar>
    <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853' }" content-position="center">基础信息</van-divider>
    <van-cell-group inset>
        <van-field label="姓名" v-model="userInfo.realName" readonly />
        <van-field label="电话" v-model="userInfo.phone" readonly />
        <van-field v-model="userInfo.hospitalName" label="体检机构" readonly />
    </van-cell-group>
    <br/>
    <van-cell-group inset>
        <van-field label="订单编号" v-model="orderPlanVo.orderId" readonly />
        <van-field label="分析计算时间" v-model="orderPlanVo.createTime" readonly />
    </van-cell-group>
    <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853' }" content-position="center">分析结果</van-divider>
    <p>基于您的当前数据，我们分析您的心脏风险情况为：</p>
    <div class="about" id="level"></div>
    <div><van-tag  type="warning" size="large">{{ userRiskLevel.userRisk.riskMessgae }}</van-tag>
    </div>
    <br/>
    <p class="text3Indentation">
    <van-notice-bar color="#a0a0a0" background="#ffffff" left-icon="guide-o">
        风险等级A，风险极低用户，继续保持现有状态
    </van-notice-bar>
    <van-notice-bar wrapable :scrollable="false"  color="#a0a0a0" background="#ffffff" left-icon="guide-o">
        风险等级B，风险低危用户，需要注意一些潜在的风险习惯
    </van-notice-bar>
    <van-notice-bar wrapable :scrollable="false"  color="#a0a0a0" background="#ffffff" left-icon="guide-o">
        风险等级C，风险中危用户，积极应对，调整不好的习惯
    </van-notice-bar>
    <van-notice-bar wrapable :scrollable="false"  color="#a0a0a0" background="#ffffff" left-icon="guide-o">
        风险等级D，风险高危用户，平时要注意身体变化，可以考虑去门诊进一步检查
    </van-notice-bar></p>
    <br/>
    <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853' }" content-position="center" dashed>钙化积分</van-divider>
    <div>钙化积分：<van-button plain type="danger">{{ userRiskLevel.userRisk.cacs }}分</van-button>
        <br/> <br/><van-tag  type="warning" size="large">属于{{
        userRiskLevel.userRisk.cacsLevel }}风险</van-tag></div>
    <van-notice-bar wrapable :scrollable="false" left-icon="info-o" color="#484848" background="#F1F1F1">
        <p class="text3Indentation">此部分是通过您的胸部CT影像数据计算得出。通对斑块的计算，可以较为客观的反映心脏血管的实际风险。(如果您的检查不含盖CT影像数据，这部分数字会为0)</p>
        <p class="text3Indentation">美国MESA通过长达10年的、近10000名用户的跟踪，该因素已经被认为具有极强的心脏健康指导意义。并被国内外顶级医疗机构纳入健康筛查和临床检查，包括国内的安贞医院、协和医院。</p>
        <p class="text3Indentation">冠状动脉钙化与冠心病存在相关关系，冠状动脉钙化是冠状动脉粥样硬化的特异性标志，冠状动脉钙化积分对发现冠状动脉粥样硬化，了解斑块分布、斑块负荷及冠心病的筛查有重要的临床意义。标准如下:</p>
    </van-notice-bar>
    <van-cell-group inset>
        <van-field label="0" model-value="风险极低" readonly />
        <van-field label="1～100" model-value="低危风险" readonly />
        <van-field label="101～400" model-value="中危风险" readonly />
        <van-field label="400以上" model-value="高危风险" readonly />
    </van-cell-group>
    <br/>
    <van-cell-group inset>
        <video id="player-container-id"  width="397" height="260" playsinline webkit-playsinline controls></video>
    </van-cell-group>
    <br/>
    <van-notice-bar wrapable :scrollable="false" left-icon="info-o">
        <p class="text2Indentation">特别说明：钙化积分只是一定程度上反映心脏血管斑块情况，受CT设备等因素影响，存在一定误差，此结果数值仅供参考。</p>
    </van-notice-bar>
    <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853' }" content-position="center" dashed>风险问题详单</van-divider>
    <van-tag color="#ffe1e1" text-color="#ad0000">风险提示</van-tag>
    <div class="about" id="risk"></div>
    <!--van-tag type="danger">高风险0条</van-tag-->
    <div><van-tag round type="warning" size="large">中危以上(含中危)风险</van-tag></div>
    <br/>
    <van-notice-bar v-for="(personRiskManager, id) in personRiskManagerList.personRiskManager" :key="id" wrapable
        :scrollable="false" background="#ffffff" left-icon="warn-o">
        <p class="text3Indentation"> {{ personRiskManager.healthRulesMessage }}</p>
    </van-notice-bar>
    <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853' }" content-position="center"
        >根据您的情况，我们调理建议如下:</van-divider>
    <van-tag color="#ffe1e1" text-color="#ad0000"> <audio :src="userOrderCard.orderPlanVo.audioSrc" ref="audio" @pause="onPause" @play="onPlay" @timeupdate="onTimeupdate"
      @canplay="onLoadedmetadata" controls ></audio></van-tag>

    <div class="van-hairline--surround">
        <van-notice-bar wrapable :scrollable="false" color="#a0a0a0" background="#ffffff">
       <p class="text3Indentation" style="white-space: pre-wrap;">{{ userOrderCard.orderPlanVo.aiDesc }}</p> 
       </van-notice-bar>
    </div>
    <van-notice-bar v-if="userInfo.isDirectZY" wrapable :scrollable="false" left-icon="info-o">
        <p class="text2Indentation">特别说明：中医在心血管一级预防阶段成效显著，同时医保惠民鼓励个人主动参与预防，本方案提供的中医调理方案由医保、企业补充医保和中医适宜性技术大比例覆盖，个人支付少。(本分析结果非诊疗推断。受限于检查数据的准确性、时效性，以及健康检查技术的局限性，此分析在已知范围存在误差)</p>
    </van-notice-bar>
    <van-notice-bar v-else wrapable :scrollable="false" left-icon="info-o">
        <p class="text2Indentation">特别说明：中医在心血管一级预防阶段成效显著，同时医保惠民鼓励个人主动参与预防。(本分析结果非诊疗推断。受限于检查数据的准确性、时效性，以及健康检查技术的局限性，此分析在已知范围存在误差)</p>
    </van-notice-bar>
    <!-- 文字较短时，通过设置 scrollable 属性开启滚动播放 -->
    <van-notice-bar v-if="userInfo.isDirectZY" scrollable text="您可以将您的数据同步到中医科室，以便科室了解您的情况。" left-icon="volume-o"/>
    <van-button v-if="userInfo.isDirectZY" color="linear-gradient(to right, #f67f34, #d55809)" round block @click="toDoctorData">了解中医科室能力</van-button>
    <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853' }" content-position="center">全国区域分析</van-divider>
    <div class="van-hairline--surround">
         <van-cell-group inset>
          <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853' }" content-position="center" dashed><p class="text3Indentation">心血管病的人群风险存在显著的地区差异，而导致各地人群风险的主要危险因素也并不相同:</p></van-divider>
          <van-notice-bar wrapable :scrollable="false" color="#a0a0a0" background="#ffffff" left-icon="aim">
            <p class="text3Indentation">1. 东北地区受副食因素（水果蔬菜摄入不足、红肉摄入过多）影响最大</p>
         </van-notice-bar>
         <van-notice-bar wrapable :scrollable="false" color="#a0a0a0"  background="#ffffff" left-icon="aim">
            <p class="text3Indentation">2. 华北、西北地区受肥胖因素和血压因素影响较大</p>
         </van-notice-bar>
         <van-notice-bar wrapable :scrollable="false" color="#a0a0a0" background="#ffffff" left-icon="aim">
            <p class="text3Indentation">3. 华东、西南地区受吸烟和饮酒因素较大</p>
         </van-notice-bar>
         <van-notice-bar wrapable :scrollable="false" color="#a0a0a0" background="#ffffff" left-icon="aim">
            <p class="text3Indentation">4. 华南地区受粗粮摄入与运动不足因素影响较大</p>
         </van-notice-bar>
          <van-image src="https://ailyway-img-1258265833.cos.ap-shanghai.myqcloud.com/xinxueguan.png" />
      </van-cell-group>
     </div>
    <van-overlay :show="showOverlay" @click="showOverlay = false">
        <div class="wrapper" @click.stop>
            <div class="block">
                <van-cell-group inset>
                    <van-notice-bar wrapable :scrollable="false" text="异常提醒" left-icon="info-o" />
                    <p class="textIndentation">
                        <van-notice-bar wrapable :scrollable="false" color="#1989fa" background="#ffffff">{{ bingingNotice
                        }}</van-notice-bar>
                    </p>
                    <van-button v-if="goToUserInfo" type="warning" block plain hairline to="bindingHosp">
                        开始绑定
                    </van-button>
                    <van-button v-if="goToAbout" type="warning" block plain hairline to="about">
                        返回项目介绍
                    </van-button>
                </van-cell-group>
            </div>
        </div>
    </van-overlay>
    <van-loading class="loading-bg" type="spinner" color="#303030" size="24px" v-show="pageLoading"/>
</template>

<script>
import { ref, toRefs, reactive, onMounted } from 'vue';
import { getUserInfo, getUserRiskLevel, getRiskManager } from '../../api/cardiovascular'
import { getUserOrderCard } from '../../api/userinfo'
import * as echarts from 'echarts';
import { getCheckBinding } from '../../api/permission'
import TCPlayer from 'tcplayer.js';
import 'tcplayer.js/dist/tcplayer.min.css';
import { showDialog } from 'vant';
import { useRouter } from 'vue-router';
import { postUserLog } from '../../api/userlog'

export default {
    setup() {
        const pageLoading = ref(true);
        const router = useRouter();
        const bingingNotice = ref('');
        const showOverlay = ref(false);
        const showBinging = ref(false);
        const goToUserInfo = ref(false);
        const goToAbout = ref(false);
        const productAction = ref(2);  
        let player = reactive(null)
        const state = reactive({
            userInfo: {
                hospitalName: '',
                realName: '',
                phone: '',
                age: '',
                isDirectZY: '',
            }
        })
        const userRiskLevel = reactive({
            userRisk: {
                riskLevel: '',
                cacs: '',
                cacsLevel: '',
                riskMessgae: '',
                highRisk: '',
                mediumRisk: '',
                lowRisk: '',
                veryLowRisk: '',
            }
        })
        const personRiskManagerList = reactive({
            personRiskManager: {
                personId: '',
                healthRulesId: '',
                healthRulesMessage: '',
                healthResults: '',
                resultsMessage: '',
            }
        })
        const userOrderCard = reactive({
            orderPlanVo: {
                wxOpenId: '',
                orderId: '',
                orderPlanId: '',
                aiDesc:'',
                audioSrc:'',
                createTime: '',
                
            }
        })
        const ulog = reactive({
                UserLog: {
                path: '',
            }
        })
        const toDoctorData = () => {
            router.push("/zhongyike/66999");
        };
        onMounted(() => {
            ulog.UserLog.path = router.currentRoute.value.fullPath;
            console.log("当前页面路径=="+ulog.UserLog.path) 
            postUserLog(ulog.UserLog).then(() => {
         
            })
            player = TCPlayer('player-container-id',
                {
                    fileID: '1253642696982514526', // 请传入需要播放的视频 fileID（必须）
                    appID: '1318167223', // 请传入点播账号的 appID（必须）
                    psign: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBJZCI6MTMxODE2NzIyMywiZmlsZUlkIjoiMTI1MzY0MjY5Njk4MjUxNDUyNiIsImN1cnJlbnRUaW1lU3RhbXAiOjE3MTU1MjUwNjUsImNvbnRlbnRJbmZvIjp7ImF1ZGlvVmlkZW9UeXBlIjoiT3JpZ2luYWwifSwidXJsQWNjZXNzSW5mbyI6eyJkb21haW4iOiIxMzE4MTY3MjIzLnZvZC1xY2xvdWQuY29tIiwic2NoZW1lIjoiSFRUUFMifX0.hmLfj15uUHfBWHlcHVLGprBIU4znR2b_cdWF7vDd-sU',  
                    licenseUrl: 'https://license.vod2.myqcloud.com/license/v2/1318167223_1/v_cube.license',
                    autoplay: false,
                    preload: 'none',
                });
            getCheckBinding().then((res1) => {
                console.log(res1.data.code);
                const binding = res1.data.code;
                if (binding == 60002) {
                    showOverlay.value = true;
                    bingingNotice.value = "【绑定进度未完成】：还没有最终确认!我们会在1～3个工作日内完成";
                    goToAbout.value = true;
                } else if (binding == 60000) {
                    showOverlay.value = true;
                    bingingNotice.value = "【绑定异常】：早知心，目前仅开放体检机构侧邀约指定客户绑定。您可以向体检机构获取【邀请码】";
                    goToUserInfo.value = true;
                } else if (binding == 40000) {
                    showOverlay.value = true;
                    bingingNotice.value = "【登陆异常】：请您在微信端打开";
                    goToAbout.value = true;
                } else {
                    getUserOrderCard().then((res) => {
                        console.log(res.data.data);
                        userOrderCard.orderPlanVo = res.data.data;
                        if(res.data.code==50001){
                            showDialog({
                                title: '数据提醒',
                                message: '未找寻到已经完成的分析记录，请尽快安排来我院进行相关检查！',
                                theme: 'round-button',
                            }).then(() => {
                                router.push('/about');
                            });
                        }else{
                             getUserRiskLevel().then((res2) => {
                                 userRiskLevel.userRisk = res2.data.data;
                                 console.log(userRiskLevel.userRisk)
                                 levelInit()
                                 riskInfo()
                            })
                             getRiskManager().then((res3) => {
                                 personRiskManagerList.personRiskManager = res3.data.data;
                                 console.log(personRiskManagerList);
                            })
                        }
                    })
                    getUserInfo().then((res1) => {
                                state.userInfo = res1.data.data;
                                console.log(res1.data.data);
                            })
                }

            })
            pageLoading.value=false;
        })
        function levelInit() {
            var myChart = echarts.init(document.getElementById("level"));
            console.log(userRiskLevel.userRisk.riskLevel);
            myChart.setOption(
                {
                    tooltip: {},
                    series: [
                        {
                            type: 'gauge',
                            startAngle: 180,
                            endAngle: 0,
                            center: ['50%', '75%'],
                            radius: '90%',
                            min: 0,
                            max: 1,
                            splitNumber: 8,
                            axisLine: {
                                lineStyle: {
                                    width: 6,
                                    color: [
                                        [0.25, '#4169e1'],
                                        [0.5, '#4ad187'],
                                        [0.75, '#FDDD60'],
                                        [1, '#FF6E76']
                                    ]
                                }
                            },
                            pointer: {
                                icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
                                length: '12%',
                                width: 20,
                                offsetCenter: [0, '-60%'],
                                itemStyle: {
                                    color: 'inherit'
                                }
                            },
                            axisTick: {
                                length: 12,
                                lineStyle: {
                                    color: 'inherit',
                                    width: 2
                                }
                            },
                            splitLine: {
                                length: 20,
                                lineStyle: {
                                    color: 'inherit',
                                    width: 5
                                }
                            },
                            axisLabel: {
                                color: '#464646',
                                fontSize: 20,
                                distance: -60,
                                rotate: 'tangential',
                                formatter: function (value) {
                                    if (value === 0.875) {
                                        return 'D';
                                    } else if (value === 0.625) {
                                        return 'C';
                                    } else if (value === 0.375) {
                                        return 'B';
                                    } else if (value === 0.125) {
                                        return 'A';
                                    }
                                    return '';
                                }
                            },
                            title: {
                                offsetCenter: [0, '-10%'],
                                fontSize: 20
                            },
                            detail: {
                                fontSize: 30,
                                offsetCenter: [0, '-35%'],
                                valueAnimation: true,
                                formatter: function (value) {
                                    if (Math.round(value * 100) > 75 && Math.round(value * 100) < 101) {
                                        return '高危';
                                    } else if (Math.round(value * 100) > 50 && Math.round(value * 100) < 76) {
                                        return '中危';
                                    } else if (Math.round(value * 100) > 25 && Math.round(value * 100) < 51) {
                                        return '低微';
                                    } else {
                                        return '极低风险';
                                    }
                                },
                                color: 'inherit'
                            },
                            data: [
                                {
                                    value: userRiskLevel.userRisk.riskLevel,
                                    name: '风险情况'
                                }
                            ]
                        }
                    ],
                });
        }
        function riskInfo() {
            var myChartRisk = echarts.init(document.getElementById("risk"));
            myChartRisk.setOption(
                {
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                        top: '5%',
                        left: 'center'
                    },
                    series: [
                        {
                            name: '风险因素识别分析',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            avoidLabelOverlap: false,
                            itemStyle: {
                                borderRadius: 10,
                                borderColor: '#fff',
                                borderWidth: 2
                            },
                            label: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: 40,
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: [
                                { value: userRiskLevel.userRisk.veryLowRisk, name: '极低风险因素' },
                                { value: userRiskLevel.userRisk.lowRisk, name: '低风险因素' },
                                { value: userRiskLevel.userRisk.mediumRisk, name: '中风险因素' },
                                { value: userRiskLevel.userRisk.highRisk, name: '高风险因素' },
                            ]
                        }
                    ],
                });

        }
        return {
            ref,
            player,
            userRiskLevel,
            productAction,
            toDoctorData,
            showOverlay,
            showBinging,
            bingingNotice,
            goToUserInfo,
            goToAbout,
            personRiskManagerList,
            userOrderCard,
            pageLoading,
            ...toRefs(userOrderCard),
            ...toRefs(state),

        }
    },
};
</script>
<style lang="less" scoped>
#level {
    height: 400px;
    width: 100%;
}

#risk {
    height: 400px;
    width: 100%;
}

.van-cell {
    border-radius: 30rpx;
    margin: 40rpx 0 0 0;
}

/* 去除单元格cell下边框 */
.van-cell:after {
    border-bottom: none !important;
    border-bottom-style: none !important;
}

/* 单元格标题title */
.van-cell .van-cell__title {
    color: #7186e1;
}

/* 标题下方label */
.van-cell .van-cell__label {
    color: #000;
    font-weight: 500;
}

.textIndentation {
    font-size: 12px;
    text-align: left;
}

.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.block {
    width: 500px;
    height: 400px;
}

.text3Indentation {
    text-align: left;
    font-weight: bold;
    font-size: 14px;
}

.text2Indentation {
    text-align: left;
    font-size: 12px;
}

.content {
    padding: 16px 16px 160px;
}
.notice-swipe {
    height: 40px;
    line-height: 40px;
  }
  .video {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.video-container {
    position: relative;
    width: 95%;
    clear: both;
    margin: 0 auto;
}
</style>